const ErrorsUtils = {
	isUserError: (err) => {
		return err && err.response && err.response.data && err.response.data.errorMessageType === 'USER';
	},
  
};

export default ErrorsUtils;
